<script setup>
import { computed } from 'vue'
import { useSiteConfigStore } from '@/stores/config/site'

const siteConfigStore = useSiteConfigStore()
const whatsappHref = computed(() => {
  return siteConfigStore.getWhatsAppLink
})
</script>

<template>
  <a v-if="whatsappHref" :href="whatsappHref" class="whatsapp" target="_blank">
    <div class="whatsAppButton scaleHover">
      <div class="layoutContainer whatsAppContainer">
        <h1 class="m-0 cursor-pointer">
          <font-awesome-icon size="2x" icon="fa-brands fa-whatsapp" />
        </h1>
      </div>
    </div>
  </a>
</template>
